import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface CoordenadaGt {
  latitude: number;
  longitude: number;
}

export interface TallerCercanoGt {
  id: number;
  nombreTaller: string;
  codigoPostal: string;
  poblacion: string;
  provincia: string;
  direccion: string;
  latitud: number;
  longitud: number;
}

@Injectable({
  providedIn: 'root'
})
export class GlassTalleresService {
  constructor(private http: HttpClient) {}

  public getGeocodeResults(direccion: string): Observable<CoordenadaGt> {
    const url =
      'https://maps.google.com/maps/api/geocode/json?address=' +
      encodeURIComponent(direccion) +
      '&region=es&language=es&sensor=false&components=country:ES&key=' +
      environment.googleMapsApiKey;

    return this.http.get(url).pipe(
      map((response: any) => {
        const results = response?.results;
        if (results && results.length > 0) {
          const location = results[0].geometry.location;
          return { latitude: location.lat, longitude: location.lng };
        }
        return { latitude: 0, longitude: 0 };
      })
    );
  }

  public buscarTalleresCercanos(token: string, latitud: number, longitud: number): Promise<any> {
    const url = environment.glassTalleresWSBase + '/gt/talleres/cercanos';
    let options = new HttpHeaders();
    options = options.set('Content-Type', 'application/json');
    options = options.set('Accept', 'application/json');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production) {
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,
      params: new HttpParams({})
    };

    const body = { latitud, longitud };

    return new Promise<any>((resolve, reject) => {
      this.http.post(url, body, httpOptions).subscribe({
        next: (response: any) => resolve(response),
        error: (err) => reject(err)
      });
    });
  }

  public crearSiniestro(token: string, arrParams: any): Promise<any> {
    let url: string = environment.glassTalleresWSBase + '/gt/siniestros';
    let options = new HttpHeaders();
    options = options.set('Content-Type', 'application/json');
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production) {
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) => {
      this.http.post(url, arrParams, httpOptions)
        .subscribe({
          next: (response: any) => resolve(response),
          error: (err) => reject(err)
        });
    });
  }

  public buscarSiniestros(token: string, matricula: string): Promise<any> {
    let url: string = environment.glassTalleresWSBase + '/gt/seguimiento';
    let options = new HttpHeaders();
    options = options.set('Content-Type', 'application/json');
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production) {
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,
      params: new HttpParams().set('matricula', matricula)
    };

    return new Promise<any>((resolve, reject) => {
      this.http.get(url, httpOptions)
        .subscribe({
          next: (response: any) => resolve(response),
          error: (err) => reject(err)
        });
    });
  }

  public buscarIncidencias(token: string, idRalarsa: string | number): Promise<any> {
    const url = environment.glassTalleresWSBase + '/gt/incidencia';
    let options = new HttpHeaders();
    options = options.set('Content-Type', 'application/json');
    options = options.set('Accept', 'application/json');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production) {
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,
      params: new HttpParams().set('id_ralarsa', String(idRalarsa))
    };

    return new Promise<any>((resolve, reject) => {
      this.http.get(url, httpOptions).subscribe({
        next: (response: any) => resolve(response),
        error: (err) => reject(err)
      });
    });
  }

  public crearIncidencia(token: string, arrParams: { otralarsa: string | number; incidencia: string }): Promise<any> {
    const url = environment.glassTalleresWSBase + '/gt/incidencia';
    let options = new HttpHeaders();
    options = options.set('Content-Type', 'application/json');
    options = options.set('Accept', 'application/json');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production) {
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,
      params: new HttpParams({})
    };

    return new Promise<any>((resolve, reject) => {
      this.http.post(url, arrParams, httpOptions).subscribe({
        next: (response: any) => resolve(response),
        error: (err) => reject(err)
      });
    });
  }
}
